import { Box, Modal } from '@mui/material';

const PDF = ({ pdf }) => {
  const STYLE = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  };

  return (
    <>
      <Box sx={STYLE}>
        <object
          data={`data:application/pdf;base64,${pdf}#navpanes=0&zoom=50`}
          type="application/pdf"
          class="internal"
          width={600}
          height={600}
        >
          <embed
            src={`data:application/pdf;base64,${pdf}`}
            type="application/pdf"
          />
        </object>
      </Box>
    </>
  );
};

const PDFModal = ({ pdfData, open, setShowPdf }) => {
  const handleClosePdfDialog = () => {
    setShowPdf(false);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClosePdfDialog}
      >
        <PDF pdf={pdfData} />
      </Modal>
    </>
  )
}

export default PDFModal;